import { PbsRestrictionType } from '@/lib/apis/types'

export const FreeTextPrescriptionContentKey = 'freeTextPrescriptionContent'

export const RESTRICTIONS_REQUIRING_APN = new Set<PbsRestrictionType>([
  'StreamlinedAuthority',
  'OnlineAuthorityRequired',
  'WrittenAuthorityRequired',
])
